import React from 'react';
import { Helmet } from 'react-helmet';

type RouterHelmetProps = {
	title?: string;
	content?: string;
};

export const RouterHelmet = ({
	title = 'Your Stash Account',
	content = 'Your Stash account',
}: RouterHelmetProps) => {
	return (
		<Helmet>
			<title>{title} | Stash</title>
			<meta name="description" content={content} />
		</Helmet>
	);
};

export default RouterHelmet;
